import React from 'react';
import Modal from "../../../shared/components/Modal";
import { Grid, Typography, Box } from "@material-ui/core";
import Loading from "../../../shared/components/Loading";
import ScrollBarGradiente from '../../../shared/components/ScrollBarGradiente';
import CardArquivo from "../../../shared/components/CardArquivo";

const ModalArquivosAmostra = ({
    amostra,
    arquivos,
    modalAberta,
    handleFecharModal,
    carregandoArquivos,
    handleBaixarArquivo }) => {



    return (
        <Modal
            modalAberto={modalAberta}
            desabilitarCliqueForaModal={false}
            iconeFechar={true}
            maxWidth={"md"}
            fecharModal={handleFecharModal}
        >
            <Grid container>
                <Grid item xs={12} className={"mb-4 mt-4"}>
                    <Typography variant="h4">
                        Amostra {amostra.codigo} - Arquivos anexados
                    </Typography>
                </Grid>
            </Grid>

            <Box className="largura-maxima mb-2">

                {carregandoArquivos ?
                    <Loading loading size={30} className={"mt-0 mb-0"} />

                    :
                    <ScrollBarGradiente
                        estilo={estilosScrollBar(arquivos.length)}
                        exibirGradiente={false}
                        habilitarScrollHorizontal={false}
                    >
                        <Grid container spacing={1} className={"pr-3"}>
                            {arquivos.map(arquivo =>
                                <Grid item xs={4} key={arquivo.id}>
                                    <CardArquivo
                                        arquivo={arquivo}
                                        excluirArquivoDesativado={true}
                                        handleBaixarArquivo={handleBaixarArquivo}
                                    />

                                </Grid>
                            )}

                        </Grid>

                    </ScrollBarGradiente>
                }

                <Typography variant="body2" className="mt-2">
                    {arquivos.length === 1
                        ? "1 anexo"
                        : arquivos.length + " anexos"}
                </Typography>
            </Box>
        </Modal>
    );
}

const alturaLinhaArquivos = 66;
const arquivosPorLinha = 3;
const alturaMinimaScroll = alturaLinhaArquivos;

const estilosScrollBar = (quantidadeArquivos) => {
    const numeroLinhas = Math.ceil(quantidadeArquivos / arquivosPorLinha);
    const altura = numeroLinhas * alturaLinhaArquivos;

    return {
        width: "100%",
        height: Math.max(alturaMinimaScroll, altura) + "px",
        maxHeight: "calc(100vh - 140px)",
        // 140 = 32 margin + 16 padding + 56 cabecalho + 28 rodape + 8 extra
    }
}

export default ModalArquivosAmostra;